import React from 'react';

export function HiddenMockup({ children }: { children: JSX.Element | JSX.Element[] }) {
  // TODO: Implement url flag to show hidden mockups
  // eslint-disable-next-line react/jsx-no-useless-fragment, no-constant-condition
  if (false) return <>{children}</>;
  return null; // TODO: <OnomyWalletSelect />;
}
